const MONTHLY_QUALITY_ANALYSIS = [
  {
    machine: "PM2",
    data: [
      {
        month: 1,
        CD_Index: 10.28,
        파강_Index: 1.100,
      },
      {
        month: 2,
        CD_Index: 9.80,
        파강_Index: 1.140,
      },
      {
        month: 3,
        CD_Index: 12.83,
        파강_Index: 1.615,
      },
      {
        month: 4,
        CD_Index: 11.05,
        파강_Index: 1.243,
      },
      {
        month: 5,
        CD_Index: 9.71,
        파강_Index: 1.132,
      },
      {
        month: 6,
        CD_Index: 15.15,
        파강_Index: 1.278,
      },
      {
        month: 7,
        CD_Index: 13.80,
        파강_Index: 1.273,
      },
      {
        month: 8,
        CD_Index: 13.80,
        파강_Index: 1.136,
      },
      {
        month: 9,
        CD_Index: 16.88,
        파강_Index: 1.024,
      },
      // {
      //   month: 10,
      //   CD_Index: 0,
      //   파강_Index: 0,
      // },
      // {
      //   month: 11,
      //   CD_Index: 0,
      //   파강_Index: 0,
      // },
      // {
      //   month: 12,
      //   CD_Index: 0,
      //   파강_Index: 0,
      // },
    ]
  },
  {
    machine: "PM3",
    data: [
      {
        month: 1,
        CD_Index: 8.18,
        파강_Index: 1.440,
      },
      {
        month: 2,
        CD_Index: 9.43,
        파강_Index: 1.454,
      },
      {
        month: 3,
        CD_Index: 10.23,
        파강_Index: 1.585,
      },
      {
        month: 4,
        CD_Index: 9.80,
        파강_Index: 1.140,
      },
      {
        month: 5,
        CD_Index: 9.71,
        파강_Index: 1.132,
      },
      {
        month: 6,
        CD_Index: 13.80,
        파강_Index: 1.273,
      },
      {
        month: 7,
        CD_Index: 16.18,
        파강_Index: 1.484,
      },
      {
        month: 8,
        CD_Index: 16.72,
        파강_Index: 1.194,
      },
      {
        month: 9,
        CD_Index: 16.88,
        파강_Index: 1.024,
      },
      {
        month: 10,
        CD_Index: 16.01,
        파강_Index: 1.525,
      },
      {
        month: 11,
        CD_Index: 13.50,
        파강_Index: 1.452,
      },
      {
        month: 12,
        CD_Index: 9.43,
        파강_Index: 1.140,
      },
    ]
  },
]

export default MONTHLY_QUALITY_ANALYSIS;